import { NgClass, NgFor, NgIf, NgStyle, CommonModule } from '@angular/common';
import { Component, effect, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash';
import { DownloadService } from 'src/app/shared/services/downloads/download.service';
import { SettingsService } from 'src/app/shared/services/settings';
import { FormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import { forkJoin } from 'rxjs';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component'; 
import { LtmsErrorComponent } from 'src/app/shared/components/ltms-error/ltms-error.component';
import { ScoreDropdownMenuComponent } from 'src/app/shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { GoogleRecaptchaService } from 'src/app/shared/services/google-recaptcha/google-recaptcha.service';
import { SearchDropdownComponent } from 'src/app/shared/components/search-dropdown/search-dropdown.component';
import { ScoreSearchBarComponent } from 'src/app/shared/components/score/score-search-bar/score-search-bar.component';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-project-user-access-settings-home',
  templateUrl: './project-user-access-settings-home.component.html',
  styleUrls: ['./project-user-access-settings-home.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, NgFor, FormsModule, ScoreDropdownMenuComponent, SearchDropdownComponent, ScoreSearchBarComponent, CommonModule, LtmsLoaderComponent, LtmsErrorComponent]
})

export class ProjectUserAccessSettingsHomeComponent implements OnInit {
    activeTab = '';
    params = {};
    tabs = ['users', 'hierarchy'];
    openRightPanel = false;
    rightPanelHeading = '';
    showThreeDropdown = false;
    @ViewChild('threeDotContainer') threeDotContainer!: ElementRef;
    @ViewChild('searchDropdownComp') SearchDropdownComponent!: SearchDropdownComponent;
    currentSubTab = 'profile';
    helpersResponse: any = {};
    pagination = {
        last_index: 0,
        page: 1
    };
    isLoading = true;
    isError = false;
    isLoadMore = false;
    checkboxFields = [
        { key: 'hasDashboardAccess' },
        { key: 'replyBackAllowed' },
        { key: 'reportDownloadAllowed' },
        // { key: 'hasStudioAccess' },
        // { key: 'hasOrganisationAccess' },
        { key: 'hasMobileAccess' }
    ];
    userList: any = [];
    filteredUserList: any = [];
    sortDirection = 'asc';
    levelList: any = {};
    levelListArray: any[] = [];
    editUserDetails: any = {};
    originalUserDetails: any = {};
    isEditModification = false;
    selectedSource = '';
    filteredOptions: any = {
        dropdownConfig: {width: '190px', isDisabled: false, tab: 'scoreViewtype'},
        emailVerificationMaster: [
            { name: 'All', value: null, field_id: 0 },
            { name: 'Verified', value: true, field_id: 1 },
            { name: 'Unverified', value: false, field_id: 2 }
        ],
        emailVerification: [],
        userType: [
            { name: 'All', value: null, field_id: 0 },
            { name: 'Internal', value: 'internal', field_id: 1 },
            { name: 'External', value: 'external', field_id: 2 }
        ],
        statusMaster: [
            { name: 'All', value: null, field_id: 0 },
            { name: 'Active', value: true, field_id: 1 },
            { name: 'Inactive', value: false, field_id: 2 },
            { name: 'Unverified', value: false, field_id: 3 }
        ],
        status: []
    };
    showRedDot = false;
    defaultSelections: any = {};
    isApplyEnabled = false;
    emailVerificationSelectedOption = '';
    statusSelectedOption = '';
    userTypeSelectedOption = '';
    emailVerificationSelectedOptionCache = '';
    statusSelectedOptionCache = '';
    userTypeSelectedOptionCache = '';
    @ViewChild('searchDropdown') searchDropdownContainer!: ElementRef;
    passwordType: any = {
        config: {width: '300px', isDisabled: false, tab: 'scoreViewtype'},
        mainPasswordType: [
            {name: 'Password', value: 'password'},
            {name: 'SSO', value: 'sso'}
        ],
        subPasswordType: {
            Password: [
                {name: 'Password', value: 'password'},
                {name: 'OTP', value: 'otp'},
                {name: 'Authenticator', value: 'authenticator'}
            ],
            SSO: [
                {name: 'Client SSO', value: 'client_sso'},
                {name: 'Server SSO', value: 'server_sso'}
            ]
        }
    }
    subPasswordTypeOptions: any = [];
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    selectedFile: File | null = null;
    selectedFileName: string = '';
    isFileReady = false;
    mainAuthTypeChangeInNewUser: string = 'Password';
    isDropdownOpen = false;
    searchTerm = '';
    selectedItems: any = [];
    options: any = [];
    hasLevelSelected = false;
    newUserFormDataFrom: any = {
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
        mainAuth: 'Password',
        subAuth: 'Password',
        mainAccess: 'Select Level',
        subAccess: [],
        is_dashboard_access: true,
        is_report_access: true,
        is_reply_access: true,
        is_setting_access: true,
        is_organisation_access: true,
        is_mobile_access: true,
        accessGroup: []
    };
    adid = '';
    isAdidCorrect = true;
    isVisibilityGroup = false;
    visibilityGroup: any = [];
    isEmailValidate = false;
    isPhoneNumberValidate = false;
    positionOfKey = 0;
    levelSearch = {width: 242, 'placeholder': 'Search Level'};
    isOptionsLoading = false;
    @ViewChild('chipDropdownContainer') chipDropdownContainer!: ElementRef;
    cohortLevels: any = [];
    cohortAccessList: any[] = [];
    filterParams: any = {};
    debounceTimer: any = '';
    apiOptions: any = [];
    verificationMailSentCache: any = [];
    isUserListLoad = false;
    insufficientAccessSubAccess: any = [];
    insufficientAccess: any = '';
    selectAll: boolean = false;
    headerToggles = {
        hasDashboardAccess: false,
        replyBackAllowed: false,
        reportDownloadAllowed: false,
        hasMobileAccess: false
    };
    showPermissionToggles = false;
    serachPayload: any = {};
    searchHasMoreData = false;
    dropdownResetKey = true;
    isUserHasWriteAccess = false;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private appStateService: AppStateService,
        private downloadService: DownloadService,
        private settingsService: SettingsService,
        private elementRef: ElementRef,
        private googleRecaptchaService: GoogleRecaptchaService,
        private cdr: ChangeDetectorRef
    ) {
        effect(() => {
            if (this.appStateService.initialized()) {
                this.isUserHasWriteAccess =this.isUserHasWriteAccessFn();
                this.helpersResponse = _.cloneDeep(this.appStateService.appState());
                this.getChorot();
                forkJoin({
                    level: this.getLevels(),
                    managers: this.getManagers(),
                }).subscribe(({ managers, level }) => {
                    this.prepareLevels(level);
                    this.createUserListTable(managers);
                });
            }
        })
    }

    isUserHasWriteAccessFn(): boolean {
        let isWriteAccess: boolean = false;
        const adminRulesDic = _.cloneDeep(Helpers?.adminRulesDic || {});
        if (adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS && !_.isEmpty(adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS) && adminRulesDic.MANAGE_ORGANIZATION_USER_ACCESS.write) {
            isWriteAccess = true;
        }else {
            isWriteAccess = false;
        }   
        return isWriteAccess;
    }

    /*
        # For status column
        Inactive   -- User does not have dashboard access. (is_veririfed: true, has_dashbaord_access: false)
        Unverified -- User has not verified their email yet. (is_veririfed: false, has_dashbaord_access: false)
        Active     -- User is email-verified and has dashboard access. (is_veririfed: true, has_dashbaord_access: true)

        # More filters
        Email verification status
        1. In Email verification status, if All option is selected, then in status it will show all options (All, Active, Inactive, Unverified).
        2. In Email verification status, if Verified option is selected, then in status it will show options (All, Active, Inactive).
        3. In Email verification status, if Unverified option is selected, then in status it will show options (All, Unverified).
        
        Status -- Vice versa
    */

    ngOnInit(): void {
        const defaultTab = this.tabs.length ? this.tabs[0] : '';
        this.route.queryParams.subscribe(params => {
            this.params = params;
            const accountId = this.params['account_id'];
            const projectId = this.params['project_id'];
            const tabFromParams = this.params['active_tab'];
            if (accountId && projectId) {
                const selectedTab = this.tabs.includes(tabFromParams) ? tabFromParams : defaultTab;
                if (this.activeTab !== selectedTab) {
                    this.activeTab = selectedTab;
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: { active_tab: selectedTab },
                        queryParamsHandling: 'merge'
                    });
                } else {
                    this.activeTab = selectedTab;
                }
            }
        });
        this.filteredOptions.status = [...this.filteredOptions.statusMaster];
        this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
        this.emailVerificationSelectedOption = this.filteredOptions.emailVerification[0].name;
        this.userTypeSelectedOption = this.filteredOptions.userType[0].name;
        this.statusSelectedOption = this.filteredOptions.status[0].name;
        this.emailVerificationSelectedOptionCache = this.filteredOptions.emailVerification[0].name;
        this.userTypeSelectedOptionCache = this.filteredOptions.userType[0].name;
        this.statusSelectedOptionCache = this.filteredOptions.status[0].name;
        this.defaultSelections = {
            emailVerification: [this.filteredOptions.emailVerification[0]],
            userType: [this.filteredOptions.userType[0]],
            status: [this.filteredOptions.status[0]]
        };
    }

    onClickingNavigation(tab) {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { active_tab: tab },
                queryParamsHandling: 'merge'
            });
        }
    }

    async onSearchChanged(event: { option: string; keyword: string }) {
        this.clearAllFilter();
        this.applyFilter(false);
        this.resetHeaderToggles();
        this.selectAll = false;
        this.showPermissionToggles = false;
        const input = (event.keyword || '').trim();
        this.selectedSource = '';
        this.filteredUserList = [];
        this.userList = [];
        this.isLoadMore = false;
        this.isLoading = true;
        this.isError = false;
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(async () => {
            if (input.length < 3) {
                this.pagination = {
                    ...this.pagination,
                    last_index: 0,
                    page: 1
                };
                this.getManagers().subscribe(response => {
                    this.filteredUserList = [];
                    this.userList = [];
                    this.createUserListTable(response);
                })
                return;
            }
            this.isLoading = true;
            this.isError = false;
            this.filteredUserList = [];
            this.userList = [];
            this.isLoadMore = false;
            this.serachPayload = {
                brand_id: this.helpersResponse?.brandDetails?._id,
                search_type: event.option === 'Name' ? 1 : 2,
                text: input,
                size: 10,
                page_number: 1
            };
            await this.fetchSearchReult();
        }, 1000);
    }

    async fetchSearchReult() {
        try {
            const response: any = await this.settingsService.searchManager(this.serachPayload).toPromise();
            if (response?.code === 0 && response?.data?.managers?.length > 0) {
                const managers = response.data.managers;
                if(managers && managers.length >= 10) {
                    this.searchHasMoreData = true;
                } else {
                    this.searchHasMoreData = false;
                }
                let managerLists: any[] = [];
                const subAccessPromises: Promise<any>[] = [];
                managers.forEach(manager => {
                    if (_.size(manager) > 0) {
                        const managerAccess = manager?.manager_access;
                        const hasAccessKey = _.get(managerAccess, 'access_key');
                        if (!_.isEmpty(hasAccessKey)) {
                            const lastKey = _.last(_.keys(hasAccessKey));
                            const rawValues = _.get(hasAccessKey, [lastKey, 'values'], []);
                            const values = Array.isArray(rawValues) ? rawValues : [rawValues];
                            const access = `${_.get(this.levelList, lastKey)} (${values.join(', ')})`;
                            managerLists.push(this.buildManagerObject(manager, managerAccess, {
                                access,
                                mainAccess: _.get(this.levelList, lastKey),
                                subAccess: values
                            }));
                        } else if (!_.isEmpty(this.levelList)) {
                            const firstLevelKey = Object.keys(this.levelList)[0];
                            const mainAccess = this.levelList[firstLevelKey];
                            const subAccessP = new Promise(resolve => {
                                const managerObj = this.buildManagerObject(manager, managerAccess, {
                                    access: this.insufficientAccess,
                                    mainAccess,
                                    subAccess: this.insufficientAccessSubAccess
                                });
                                managerLists.push(managerObj);
                                resolve(null);
                            });
                            subAccessPromises.push(subAccessP);
                        }
                    }
                });
                await Promise.all(subAccessPromises);
                const emailCounts = managerLists.reduce((acc, manager) => {
                    const email = manager.emailId || 'Not Available';
                    acc[email] = (acc[email] || 0) + 1;
                    return acc;
                }, {} as Record<string, number>);
                managerLists = managerLists.map(manager => {
                    const email = manager.emailId || 'Not Available';
                    const count = emailCounts[email];
                    return {
                        ...manager,
                        emailIdWithCount: `${email} (${count})`
                    };
                });
                this.userList = [...this.userList, ...managerLists].sort((a, b) => {
                    const dir = this.sortDirection === 'desc' ? -1 : 1;
                    return dir * (a.emailId || '').localeCompare(b.emailId || '');
                });
                const filtered = this.userList.filter(item => {
                    const hasType2 = this.userList.some(x => x.emailId === item.emailId && x.managerType === 2);
                    if (hasType2) {
                        return item.managerType === 2;
                    }
                    return true;
                });
                this.filteredUserList = [...filtered];
                this.isLoading = false;
                this.isError = this.filteredUserList.length === 0;
            } else {
                this.userList = [];
                this.filteredUserList = [];
                this.isLoading = false;
                this.isError = true;
            }
        } catch (error) {
            this.userList = [];
            this.filteredUserList = [];
            this.isLoading = false;
            this.isError = true;
        }
    }

    checkBoxButtonToggle(source) {
        this.SearchDropdownComponent.clearSearch(false);
        this.resetHeaderToggles();
        this.selectAll = false;
        this.showPermissionToggles = false;
        if(source === this.selectedSource) {
            this.selectedSource = '';
        } else {
            this.selectedSource = source;
        }
        this.pagination = {
            last_index: 0,
            page: 1
        }
        delete this.pagination['last_id'];
        this.getManagers().subscribe(managers => {
            this.userList = [];
            this.createUserListTable(managers);
        })
    }

    onFilterChange(event, filterType) {
        if (filterType === 'emailVerification') {
            this.emailVerificationSelectedOptionCache = event.name;
            if (event.value === null) {
                this.filteredOptions.status = [...this.filteredOptions.statusMaster];
            } else if (event.value === true) {
                this.filteredOptions.status = this.filteredOptions.statusMaster.filter(
                    item => item.name !== 'Unverified'
                );
            } else if (event.value === false) {
                this.filteredOptions.status = this.filteredOptions.statusMaster.filter(
                   item => item.name !== 'Active' && item.name !== 'Inactive'
                );
            }
            if (!this.filteredOptions.status.some(s => s.name === this.statusSelectedOptionCache)) {
                this.statusSelectedOptionCache = 'All';
                this.statusSelectedOption = 'All';
            }
        } else if (filterType === 'userType') {
            this.userTypeSelectedOptionCache = event.name;
        } else if (filterType === 'status') {
            this.statusSelectedOptionCache = event.name;
            if (event.value === null) { 
                this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
            } else if (event.name === 'Active' || event.name === 'Inactive') {
                this.filteredOptions.emailVerification = this.filteredOptions.emailVerificationMaster.filter(
                    item => item.name !== 'Unverified'
                );
            } else if (event.name === 'Unverified') {
                this.filteredOptions.emailVerification = this.filteredOptions.emailVerificationMaster.filter(
                    item => item.name !== 'Verified'
                );
            }
            if (!this.filteredOptions.emailVerification.some(ev => ev.name === this.emailVerificationSelectedOptionCache)) {
                this.emailVerificationSelectedOptionCache = 'All';
                this.emailVerificationSelectedOption = 'All';
            }
        }
        this.syncAllDropdowns(
            this.emailVerificationSelectedOptionCache,
            this.statusSelectedOptionCache
        );
        this.checkIfApplyEnabled();
    }

    checkIfApplyEnabled() {
        this.isApplyEnabled = !(
            this.emailVerificationSelectedOptionCache === this.defaultSelections.emailVerification[0].name &&
            this.userTypeSelectedOptionCache === this.defaultSelections.userType[0].name &&
            this.statusSelectedOptionCache === this.defaultSelections.status[0].name
        );
    }

    applyFilter(emit=true) {
        this.defaultSelections = {
            emailVerification: [this.filteredOptions.emailVerificationMaster.find(item => item.name === this.emailVerificationSelectedOptionCache)],
            userType: [this.filteredOptions.userType.find(item => item.name === this.userTypeSelectedOptionCache)],
            status: [this.filteredOptions.statusMaster.find(item => item.name === this.statusSelectedOptionCache)]
        };
        this.closeRightPanelFN('Add Filter');
        this.isApplyEnabled = false;
        const emailSelection = this.defaultSelections.emailVerification[0];
        const userTypeSelection = this.defaultSelections.userType[0];
        const statusSelection = this.defaultSelections.status[0];
        this.pagination = {
            last_index: 0,
            page: 1
        };
        delete this.pagination['last_id'];
        this.filterParams = {};
        if (emailSelection && emailSelection.name !== 'All') {
            this.filterParams['is_verified'] = emailSelection.value;
        }
        if (userTypeSelection && userTypeSelection.name !== 'All') {
            this.filterParams['user_type'] = userTypeSelection.value;
        }
        if (statusSelection && statusSelection.name !== 'All') {
            switch (statusSelection.name) {
                case 'Active':
                case 'Inactive':
                    this.filterParams['has_dashboard_access'] = statusSelection.value;
                    break;
                case 'Unverified':
                    this.filterParams['is_verified'] = false;
                    break;
            }
        }
        const allAreAll = emailSelection?.name === 'All' && userTypeSelection?.name === 'All' && statusSelection?.name === 'All';
        this.showRedDot = !allAreAll;
        if(!emit) return;
        this.SearchDropdownComponent.clearSearch(false);
        this.getManagers().subscribe(managers => {
            this.userList = [];
            this.createUserListTable(managers);
        });
    }

    openRightPanelFN(event, data) {
        if(!this.isUserHasWriteAccess && (event === 'Edit user' || event === 'New User Access')) {
            Helpers.smallAlertBox('Access Denied', 'You do not have write permission to update user details. Only read access is available.', 'warning', 4000);
            return;
        }
        this.openRightPanel = true;
        this.rightPanelHeading = event;
        this.resetHeaderToggles();
        this.selectAll = false;
        this.showPermissionToggles = false;
        if(event === 'Edit user') {
            this.editUser(data);
        } else if(event === 'Add Filter') {
            this.emailVerificationSelectedOption =
            this.defaultSelections.emailVerification[0].name;
            this.userTypeSelectedOption =
            this.defaultSelections.userType[0].name;
            this.statusSelectedOption =
            this.defaultSelections.status[0].name;
            this.emailVerificationSelectedOptionCache = this.emailVerificationSelectedOption;
            this.userTypeSelectedOptionCache = this.userTypeSelectedOption;
            this.statusSelectedOptionCache = this.statusSelectedOption;
            this.filteredOptions.status = [...this.filteredOptions.statusMaster];
            this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
            this.isApplyEnabled = false;
            this.applyEmailToStatusRules(this.emailVerificationSelectedOption);
            this.applyStatusToEmailRules(this.statusSelectedOption);
            this.syncAllDropdowns(
                this.emailVerificationSelectedOptionCache,
                this.statusSelectedOptionCache
            );
            this.checkIfApplyEnabled();
        } else if(event === 'New User Access') {
            this.resetNewUserForm();
            this.subPasswordTypeOptions = this.passwordType.subPasswordType['Password'];
            this.isVisibilityGroup = this.isVisibilityGroupFn();
        }
    }

    applyEmailToStatusRules(emailName: string) {
        switch (emailName) {
            case 'Verified':
                this.filteredOptions.status = this.filteredOptions.statusMaster.filter(
                    s => s.name === 'All' || s.name === 'Active' || s.name === 'Inactive'
                );
                break;

            case 'Unverified':
                this.filteredOptions.status = this.filteredOptions.statusMaster.filter(
                    s => s.name === 'All' || s.name === 'Unverified'
                );
                break;

            default:
                this.filteredOptions.status = [...this.filteredOptions.statusMaster];
        }
    }

    applyStatusToEmailRules(statusName: string) {
        switch (statusName) {
            case 'Active':
            case 'Inactive':
                this.filteredOptions.emailVerification = this.filteredOptions.emailVerificationMaster.filter(
                    e => e.name === 'All' || e.name === 'Verified'
                );
                break;

            case 'Unverified':
                this.filteredOptions.emailVerification = this.filteredOptions.emailVerificationMaster.filter(
                    e => e.name === 'All' || e.name === 'Unverified'
                );
                break;

            default:
                this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
        }
    }

    resetNewUserForm() {
        this.newUserFormDataFrom = {
            firstName: '',
            lastName: '',
            emailAddress: '',
            phoneNumber: '',
            mainAuth: 'Password',
            subAuth: 'Password',
            mainAccess: 'Select Level',
            subAccess: [],
            is_dashboard_access: true,
            is_report_access: true,
            is_reply_access: true,
            is_setting_access: true,
            is_organisation_access: true,
            is_mobile_access: true,
            accessGroup: []
        };
        this.adid = '';
        this.currentSubTab = 'profile';
        this.visibilityGroup = [];
        this.mainAuthTypeChangeInNewUser = 'Password';
        this.subPasswordTypeOptions = [];
        this.options = [];
        this.selectedItems = [];
        this.searchTerm = '';
        this.isDropdownOpen = false;
        this.hasLevelSelected = false;
        this.restoreSelectLevelOption();
    }

    restoreSelectLevelOption() {
        const hasSelectLevel = this.levelListArray.some((level: any) => level.name === 'Select Level');
        if (!hasSelectLevel) {
            this.levelListArray = [{ filed_id: null, name: 'Select Level' }, ...this.levelListArray] as any[];
        }
    }

    closeRightPanelFN(tab) {
        this.openRightPanel = false;
        this.rightPanelHeading = '';
        if(tab === 'Import Users') {
            this.selectedFile = null;
            this.selectedFileName = '';
            this.isFileReady = false;
        } else if(tab === 'Edit user') {
            this.options = [];
            this.selectedItems = [];
            this.apiOptions = [];
            this.searchTerm = '';
            this.editUserDetails = {...this.originalUserDetails};
            this.isEditModification = false;
        } else if(tab === 'New User Access') {
            this.resetNewUserForm();
        } else if(tab === 'Add Filter') {
            this.emailVerificationSelectedOption = this.defaultSelections.emailVerification[0].name;
            this.userTypeSelectedOption = this.defaultSelections.userType[0].name;
            this.statusSelectedOption = this.defaultSelections.status[0].name;
            this.emailVerificationSelectedOptionCache = this.defaultSelections.emailVerification[0].name;
            this.userTypeSelectedOptionCache = this.defaultSelections.userType[0].name;
            this.statusSelectedOptionCache = this.defaultSelections.status[0].name;
            this.filteredOptions.status = [...this.filteredOptions.statusMaster];
            this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
            this.checkIfApplyEnabled();
        }
    }

    showThreeDropdownFN() {
        this.showThreeDropdown = !this.showThreeDropdown;
        if (this.showThreeDropdown) {
            document.addEventListener('click', this.handleClickOutside);
        } else {
            document.removeEventListener('click', this.handleClickOutside);
        }
    }

    handleClickOutside = (event: MouseEvent) => {
        const threeDot = this.threeDotContainer?.nativeElement;
        const searchDropdown = this.searchDropdownContainer?.nativeElement;
        const target = event.target as HTMLElement;
        const isClickInsideThreeDot = threeDot && threeDot.contains(target);
        if (!isClickInsideThreeDot) {
            this.showThreeDropdown = false;
        }
        if (!isClickInsideThreeDot) {
            document.removeEventListener('click', this.handleClickOutside);
        }
    };

    changeSubTab(tab: string) {
        if (tab === 'access' && !this.isProfileFormValid()) {
            Helpers.smallAlertBox("ERROR", 'Please complete all required fields in the profile form.', "ERROR", 5000);
            return;
        }
        this.currentSubTab = tab;
    }

    createJob() {
        const payload = {
            brand_id: this.helpersResponse?.brandDetails?._id,
            job_type: 7,
            report_type: "brand"
        }
        this.downloadService.createDashboardReportJob(payload).subscribe(response => {
            if (response && response.code == 0 && response.data && response.data.ops && response.data.ops.length > 0) {
                Helpers.smallAlertBox("SUCCESS", 'Your request has been submitted successfully, you will receive report through email shortly', "SUCCESS", 5000);
            } else if(response && response.code == 0 && response.data && response.data.code == 4021) {
                Helpers.smallAlertBox("ERROR", 'Request is already submitted', "ERROR", 5000);
            } else {
                Helpers.smallAlertBox("ERROR", 'Something went wrong, please try again', "ERROR", 5000);
            }
        });
    }

    getLevels() {
        const hierarchyList = _.get(this.helpersResponse, 'brandDetails.hierarchy_list');
        const hierarchyListAlias = _.get(this.helpersResponse, 'brandDetails.hierarchy_list_alias');
        if (!hierarchyList || !hierarchyListAlias) {
            return;
        }
        const labelKey = Object.keys(hierarchyList).find(
            key => Array.isArray(hierarchyList[key]) && hierarchyList[key].length > 0
        );
        const names = labelKey ? hierarchyList[labelKey] : [];
        const aliasKey = Object.keys(hierarchyListAlias).find(
            key => hierarchyListAlias[key] && Array.isArray(hierarchyListAlias[key].values) && hierarchyListAlias[key].values.length > 0
        );
        const keys = aliasKey ? hierarchyListAlias[aliasKey].values : [];
        const mappedObj = {};
        keys.forEach((key, index) => {
            mappedObj[key] = names[index];
        });
        const dropdown = [
            { filed_id: null, name: 'Select Level' },
            ...keys.map((key, index) => {
                const name = names[index];
                return name !== undefined ? { filed_id: key, name } : null;
            }).filter(Boolean)
        ];
        this.levelList = mappedObj;
        this.levelListArray = dropdown;
        const firstLevelKey = Object.keys(this.levelList)[0];
        const payload = {
            brand_id: this.helpersResponse?.brandDetails?._id,
            level: firstLevelKey
        };
        return this.settingsService.getDynamicHierarchyList(payload);
    }

    getManagers() {
        this.isLoading = true;
        this.isError = false;
        this.isUserListLoad = false;
        const payload = {
            account_id: this.helpersResponse?.accountDetails?._id,
            brand_id: this.helpersResponse?.brandDetails?._id,
            filter_internal_users: false,
            filter_logged_in_manager: false,
            limit: 10,
            sort_by: 1,
            ...(this.selectedSource && { source: this.selectedSource }),
            ...this.pagination,
            ...this.filterParams
        };
        return this.settingsService.getManagerListsOrganisation(payload); 
    }

    prepareLevels(level) {
        const firstLevelKey = Object.keys(this.levelList)[0];
        const mainAccess = this.levelList[firstLevelKey];
        const subAccess = level?.data?.level_values?.map(item => item.name) || [];
        const access = `${mainAccess} (${subAccess.join(', ')})`;
        this.insufficientAccessSubAccess = subAccess;
        this.insufficientAccess = access;
    }

    private buildManagerObject(manager, managerAccess, params: { access: string, mainAccess: any, subAccess: any[] }) {
        const { access, mainAccess, subAccess } = params;
        const firstName = manager?.first_name ? manager.first_name.trim() : '';
        const lastName = manager?.last_name ? manager.last_name.trim() : '';
        const originalName = manager?.name ? manager.name.trim() : '';
        const userName = manager?.user_name;
        let name = '';
        if(firstName && lastName) {
            name = `${firstName} ${lastName}`;
        } else if(originalName) {
            name = originalName;
        } else if(userName) {
            name = userName;
        }
        const moduleConfigurations = _.get(managerAccess, 'module_configuration_v2');
        const hasStudioAccess = _.get(moduleConfigurations, 'studio.visible');
        const hasOrganisationAccess = _.get(moduleConfigurations, 'studio.sub_modules.organisation.visible');
        const mainAuthType = _.get(manager, 'authentication') && _.last(_.get(manager, 'authentication'))?.type;
        const subAuthType = _.get(manager, 'authentication') && _.last(_.get(manager, 'authentication'))?.sub_type;
        let processedMainAuthType = mainAuthType ? mainAuthType.charAt(0).toUpperCase() + mainAuthType.slice(1) : '';
        let processedSubAuthType = subAuthType ? subAuthType.charAt(0).toUpperCase() + subAuthType.slice(1) : '';
        return {
            name,
            emailId: manager?.email_address || '',
            phoneNumber: manager?.phone_number || 'Phone Number NA',
            managerType: managerAccess?.manager_type || null,
            createdDate: managerAccess?.created_date || null,
            source: managerAccess?.source || null,
            isVerified: managerAccess?.is_verified || null,
            hasDashboardAccess: managerAccess?.has_dashboard_access || null,
            replyBackAllowed: managerAccess?.reply_back_allowed || null,
            reportDownloadAllowed: managerAccess?.report_download_allowed || null,
            // hasStudioAccess,
            // hasOrganisationAccess,
            hasMobileAccess: managerAccess?.has_mobile_access || null,
            access,
            statusInfo: this.getStatus(managerAccess?.is_verified || null, managerAccess?.has_dashboard_access || null),
            managerFullDetails: manager,
            mainAuthType: processedMainAuthType,
            subAuthType: processedSubAuthType,
            mainAccess: mainAccess,
            subAccess: subAccess,
            doc_last_updated_on: manager?.doc_last_updated_on,
            uuid: uuidv4(),
            selected: this.selectAll ? true : false
        }
    }

    async createUserListTable(response) {
        const previousSelectionsMap = new Map(
            this.filteredUserList.map(u => [u.uuid, u.selected])
        );
        if(response && response.code == 0 && response.data && response.data.managers && response.data.managers.length > 0) {
            const lastId = _.get(response, 'data.last_id');
            const lastIndex = _.get(response, 'data.last_index');
            const managers = response.data.managers;
            if(managers.length >= 10) {
                this.isLoadMore = true;
                this.pagination = {
                    last_index: lastIndex, 
                    page: this.pagination.page + 1 
                }
                this.pagination['last_id'] = lastId;
            } else {
                this.isLoadMore = false;
            }
            let managerLists: any = [];
            const subAccessFulfillments: Promise<any>[] = [];
            managers.forEach(manager => {
                if(_.size(manager) > 0) {
                    const managerAccess = manager?.manager_access;
                    const hasAccessKey = _.get(managerAccess, 'access_key');
                    if (!_.isEmpty(hasAccessKey)) {
                        const lastKey = _.last(_.keys(hasAccessKey));
                        const rawValues = _.get(hasAccessKey, [lastKey, 'values'], []);
                        const values = Array.isArray(rawValues) ? rawValues : [rawValues];
                        const access = `${_.get(this.levelList, lastKey)} (${values.join(', ')})`;
                        const managerObj = this.buildManagerObject(manager, managerAccess, {
                            access,
                            mainAccess: _.get(this.levelList, lastKey),
                            subAccess: values
                        });
                        managerLists.push(managerObj);
                    } else if (!_.isEmpty(this.levelList)) {
                        const firstLevelKey = Object.keys(this.levelList)[0];
                        const mainAccess = this.levelList[firstLevelKey];
                        const subAccessP = new Promise(resolve => {
                            const managerObj = this.buildManagerObject(manager, managerAccess, {
                                access: this.insufficientAccess,
                                mainAccess,
                                subAccess: this.insufficientAccessSubAccess
                            });
                            managerLists.push(managerObj);
                            resolve(null);
                        });
                        subAccessFulfillments.push(subAccessP);
                    }
                }
            });
            await Promise.all(subAccessFulfillments);
            this.userList = [...this.userList, ...managerLists].sort((a, b) => {
                const dir = this.sortDirection === 'desc' ? -1 : 1;
                return dir * (a.emailId || '').localeCompare(b.emailId || '');
            });
            const filtered = this.userList.filter(item => {
                const hasType2 = this.userList.some(x => x.emailId === item.emailId && x.managerType === 2);
                if (hasType2) {
                    return item.managerType === 2;
                }
                return true;
            });
            const emailCounts = filtered.reduce((acc, manager) => {
                const email = manager.emailId || 'Not Available';
                acc[email] = (acc[email] || 0) + 1;
                return acc;
            }, {});
            const finalResult = filtered.map(manager => {
                const email = manager.emailId || 'Not Available';
                const count = emailCounts[email];
                return {
                    ...manager,
                    emailIdWithCount: `${email} (${count})`
                };
            });
            this.filteredUserList = finalResult.map(user => {
                const prevSelected = previousSelectionsMap.get(user.uuid);
                return {
                    ...user,
                    selected: prevSelected !== undefined ? prevSelected : user.selected
                };
            });
            if(this.filteredUserList.length === 0) {
                this.isLoading = false;
                this.isError = true;
            } else {
                this.isLoading = false;
                this.isError = false;
            }
        } else {
            this.isLoadMore = false;
            if (this.pagination.page === 1) {
                this.isLoading = false;
                this.isError = true;
            } else {
                this.isLoading = false;
                this.isError = false;
            }
        }
        this.isUserListLoad = true;
    }

    getUserType(email) {
        return (email || '').includes('@litmusworld.com') ? 'Internal' : 'External';
    }

    getDateTime(createdDate: string): string {
        const date = new Date(createdDate);
        const options: Intl.DateTimeFormatOptions = {
            timeZone: 'Asia/Kolkata',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        };
        const formatter = new Intl.DateTimeFormat('en-GB', options);
        const parts = formatter.formatToParts(date);
        const day = parts.find(p => p.type === 'day')?.value;
        const month = parts.find(p => p.type === 'month')?.value;
        const year = parts.find(p => p.type === 'year')?.value;
        const hour = parts.find(p => p.type === 'hour')?.value;
        const minute = parts.find(p => p.type === 'minute')?.value;
        return `${day} - ${month} - ${year} ${hour}:${minute}`;
    }

    getStatus(isVerified, hasDashboardAccess) {
        if (!isVerified) {
            return { status: 'Unverified', bgColor: '#FFF4E5' };
        }
        return hasDashboardAccess ? { status: 'Active', bgColor: '#E6F4EA' } : { status: 'Inactive', bgColor: '#F0F0F0' };
    }

    onCheckboxChange(user, field, event): void {
        const checked = (event.target as HTMLInputElement).checked;
        user[field] = checked;
        if (field === 'hasDashboardAccess' && !checked) {
            this.checkboxFields.forEach(f => {
                if (f.key !== 'hasDashboardAccess') {
                    user[f.key] = false;
                }
            });
        }
        user['statusInfo'] = this.getStatus(user.isVerified, user.hasDashboardAccess);
        this.updateManager(user, 'checkBox');
    }

    updateManager(managerDetails, type) {
        let payload: any = {};
        if(type === 'checkBox') {
            payload = {
                brand_id: this.helpersResponse?.brandDetails?._id,
                manager_type: _.get(managerDetails, 'managerFullDetails.manager_access.manager_type'),
                account_id: this.helpersResponse?.accountDetails?._id,
                created_date: _.get(managerDetails, 'managerFullDetails.manager_access.created_date'),
                verification_code: _.get(managerDetails, 'managerFullDetails.manager_access.verification_code'),
                source: "LW3",
                created_by: _.get(managerDetails, 'managerFullDetails.manager_access.created_by'),
                is_verified: _.get(managerDetails, 'managerFullDetails.manager_access.is_verified'),
                token_expires_on: _.get(managerDetails, 'managerFullDetails.manager_access.token_expires_on'),
                verified_on: _.get(managerDetails, 'managerFullDetails.manager_access.verified_on'),
                access_expired_on: _.get(managerDetails, 'managerFullDetails.manager_access.access_expired_on'),
                has_dashboard_access: _.get(managerDetails, 'hasDashboardAccess') ? true : false,
                reply_back_allowed: _.get(managerDetails, 'replyBackAllowed') ? true : false,
                report_download_allowed: _.get(managerDetails, 'reportDownloadAllowed') ? true : false,
                has_mobile_access: _.get(managerDetails, 'hasMobileAccess') ? true : false,
                module_configuration_v2: {
                    advanced_download: {
                        visible: _.get(managerDetails, 'reportDownloadAllowed') ? true : false,
                    },
                    studio: {
                        visible: _.get(managerDetails, 'hasStudioAccess') ? true : false,
                        sub_modules: {
                            organisation: {
                                visible: _.get(managerDetails, 'hasOrganisationAccess') ? true : false,
                            }
                        }
                    }
                },
                dynamic_properties: _.get(managerDetails, 'managerFullDetails.manager_access.dynamic_properties'),
                access_key: _.get(managerDetails, 'managerFullDetails.manager_access.access_key'),
                group_key: _.get(managerDetails, 'managerFullDetails.manager_access.group_key'),
                last_updated_by: _.get(managerDetails, 'managerFullDetails.manager_access.last_updated_by'),
                last_updated_on: _.get(managerDetails, 'managerFullDetails.manager_access.last_updated_on'),
                access_active_date: _.get(managerDetails, 'managerFullDetails.manager_access.access_active_date'),
                is_only_promoter_user: _.get(managerDetails, 'managerFullDetails.manager_access.is_only_promoter_user'),
                accessLevelValues: _.get(managerDetails, 'access'),
                created_date_formatted: _.get(managerDetails, 'managerFullDetails.manager_access.created_date'),
                config_v2: {
                    advanced_download: {
                        visible: _.get(managerDetails, 'reportDownloadAllowed') ? true : false,
                    },
                    studio: {
                        visible: _.get(managerDetails, 'hasStudioAccess') ? true : false,
                        sub_modules: {
                            organisation: {
                                visible: _.get(managerDetails, 'hasOrganisationAccess') ? true : false,
                            }
                        }
                    }
                },
                manager_id: _.get(managerDetails, 'managerFullDetails._id'),
                updation_type: 2,
                is_access_level: _.get(managerDetails, 'access') ? true : false
            }
        }
        this.settingsService.updateManagerOrganisation(payload, this.helpersResponse?.brandDetails?._id).subscribe(response => {
            if(response && response.code === 0 && response.data && response.data.code === 0) {
                Helpers.smallAlertBox("SUCCESS", 'Changes have been updated successfully.', "SUCCESS", 5000);
            } else {
                Helpers.smallAlertBox("ERROR", 'Something went wrong, please try again', "ERROR", 5000);
            }
        })
    }

    editUser(userData) {
        const subAccessValue = _.get(userData, 'subAccess');
        const subAccessString = Array.isArray(subAccessValue) ? subAccessValue.join(', ') : (subAccessValue || '');
        const detaliedObj = {
            firstName: _.get(userData, 'managerFullDetails.first_name') || '',
            lastName: _.get(userData, 'managerFullDetails.last_name') || '',
            emailId: _.get(userData, 'managerFullDetails.email_address') || '',
            phoneNumber: _.get(userData, 'managerFullDetails.phone_number') || '',
            mainAuthType: this.transformMainAuthType(_.get(userData, 'mainAuthType')),
            mainAuthTypeShadow: this.transformMainAuthType(_.get(userData, 'mainAuthType')),
            subAuthType: this.transformSubAuthType(_.get(userData, 'subAuthType')),
            subAuthTypeShadow: this.transformSubAuthType(_.get(userData, 'subAuthType')),
            mainAccess: _.get(userData, 'mainAccess'),
            subAccess: subAccessString,
            subAccessArray: subAccessValue,
            userFullDetails: userData,
            managerType: _.get(userData, 'managerFullDetails.manager_access.manager_type')
        };
        this.subPasswordTypeOptions = this.passwordType['subPasswordType'][detaliedObj.mainAuthType];
        this.editUserDetails = {...detaliedObj};
        this.originalUserDetails = {...detaliedObj};
    }

    transformMainAuthType(type) {
        if (!type) return 'Password';
        const lowerType = type ? type.toLowerCase() : '';
        return lowerType === 'sso' ? 'SSO' : 'Password';
    }

    transformSubAuthType(type) {
        if (!type) return '';
        const lowerType = type ? type.toLowerCase() : '';
        if (lowerType === 'otp') return 'OTP';
        if (lowerType === 'authenticator') return 'Authenticator';
        if (lowerType === 'client_sso') return 'Client SSO';
        if (lowerType === 'server_sso') return 'Server SSO';
        if (lowerType === 'password') return 'Password';
        return type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
    }

    transformAuthTypeForAPI(displayName) {
        if (!displayName) return 'password';
        return displayName ? displayName.toLowerCase() === 'sso' ? 'sso' : 'password' : 'password';
    }

    transformSubAuthTypeForAPI(displayName) {
        if (!displayName) return 'password';
        const lowerName = displayName ? displayName.toLowerCase() : '';
        if (lowerName === 'otp') return 'otp';
        if (lowerName === 'authenticator') return 'authenticator';
        if (lowerName === 'client sso') return 'client_sso';
        if (lowerName === 'server sso') return 'server_sso';
        if (lowerName === 'password') return 'password';
        return 'password';
    }

    onMainAuthTypeChange(selectedOption, type) {
        if (type === 'mainAuth') {
            const newMainAuthType = selectedOption.name;
            if (this.editUserDetails.mainAuthType !== newMainAuthType) {
                this.editUserDetails.mainAuthType = newMainAuthType;
                this.editUserDetails.mainAuthTypeShadow = newMainAuthType;
                const newSubOptions = this.passwordType.subPasswordType[selectedOption.name];
                this.subPasswordTypeOptions = newSubOptions;
                if (newSubOptions && newSubOptions.length > 0) {
                    this.editUserDetails.subAuthType = newSubOptions[0].name;
                    this.editUserDetails.subAuthTypeShadow = newSubOptions[0].name;
                }
            }
        }
        if (type === 'subAuth') {
            this.editUserDetails.subAuthType = selectedOption.name;
            this.editUserDetails.subAuthTypeShadow = selectedOption.name;
        }
    }

    checkForModification() {
        const editDetailsForComparison = {
            ...this.editUserDetails,
            subAccess: this.editUserDetails.subAccess ? this.editUserDetails.subAccess : []
        };
        const originalDetailsForComparison = {
            ...this.originalUserDetails,
            subAccess: this.originalUserDetails.subAccessArray || []
        };
        const isModified = !_.isEqual(editDetailsForComparison, originalDetailsForComparison) && this.editUserDetails.subAccess.length > 0;
        this.isEditModification = isModified;
    }

    subAcessLevelChange(event, type) {
        const accessLevel = _.get(this.editUserDetails, 'userFullDetails.managerFullDetails.manager_access.access_key');
        const key = Object.keys(accessLevel)[0];
        if(type === 'focus') {
            this.hasLevelSelected = true;
            this.isOptionsLoading = true;
            this.selectedItems = [...this.originalUserDetails.subAccessArray];
            this.editUserDetails.subAccess = '';
            const payload = {
                brand_id: this.helpersResponse?.brandDetails?._id,
                level: key,
                size: 40
            };
            this.settingsService.getDynamicHierarchyList(payload).subscribe(response => {
                this.isOptionsLoading = false;
                if(response && response.code === 0 && response.data.code === 0) {
                    this.options = response.data.level_values.map(item => item.name);
                }
            })
        } else if(type === 'change') {
            this.apiOptions = [];
            this.searchTerm = event;
            const payload = {
                brand_id: this.helpersResponse?.brandDetails?._id,
                level: key,
                value: this.searchTerm
            };
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.settingsService.getDynamicHierarchyList(payload).subscribe({
                    next: response => {
                        if (response?.data?.is_value_available) {
                            this.apiOptions = response.data.level_values.map(item => item.name);
                        } else {
                            this.apiOptions = [];
                        }
                    },
                    error: err => {
                        this.apiOptions = [];
                    }
                });
            }, 500);
        }
    }

    upadteUserDetails(userDetails) {
        if(!this.isEditModification) return;
        const paylaod = {
            first_name: _.get(userDetails, 'firstName'),
            last_name: _.get(userDetails, 'lastName'),
            phone_number: _.get(userDetails, 'phoneNumber'),
            access_key: _.get(userDetails, 'userFullDetails.managerFullDetails.manager_access.access_key'),
            brand_id: this.helpersResponse?.brandDetails?._id,
            config_v2: _.get(userDetails, 'userFullDetails.managerFullDetails.manager_access.module_configuration_v2'),
            is_access_level: true,
            is_deactivated: _.get(userDetails, 'userFullDetails.managerFullDetails.is_deactivated') || false,
            is_only_promoter_user: _.get(userDetails, 'userFullDetails.managerFullDetails.is_only_promoter_user'),
            manager_id: _.get(userDetails, 'userFullDetails.managerFullDetails._id'),
            source: "LW3",
            type: this.transformAuthTypeForAPI(_.get(userDetails, 'mainAuthType')),
            sub_type: this.transformSubAuthTypeForAPI(_.get(userDetails, 'subAuthType')),
            updation_type: 2
        }
        for (const key in paylaod.access_key) {
            if (paylaod.access_key[key]?.values) {
                const subAccess = _.get(userDetails, 'subAccess', '');
                paylaod.access_key[key].values = subAccess ? subAccess : [];
            }
        }
        if(this.hasUserDetailsChanged(this.originalUserDetails, this.editUserDetails)) {
            paylaod['is_access_level'] = false;
        }
        this.SearchDropdownComponent.clearSearch(false);
        this.settingsService.updateManagerOrganisation(paylaod, this.helpersResponse?.brandDetails?._id).subscribe(response => {
            this.closeRightPanelFN('Edit user');
            if(response.code == 0 && response.data && response.data.code == 0) {
                Helpers.smallAlertBox("SUCCESS", 'Manager updated successfully', "SUCCESS", 5000);
                this.userList = [];
                this.filteredUserList = [];
                this.pagination = {
                    last_index: 0,
                    page: 1
                }
                this.isLoadMore = false;
                this.getManagers().subscribe(response => {
                    this.createUserListTable(response);
                })
            } else {
                Helpers.smallAlertBox("ERROR", 'Something went wrong, please try again', "ERROR", 5000);
            }
        })
    }

    hasUserDetailsChanged(original, edited) {
        return (
            original.firstName !== edited.firstName ||
            original.lastName !== edited.lastName ||
            original.phoneNumber !== edited.phoneNumber
        );
    }

    sortByEmail() {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.filteredUserList.sort((a, b) => {
            const nameA = a.emailId ? a.emailId.toLowerCase() : '';
            const nameB = b.emailId ? b.emailId.toLowerCase() : '';
            if (this.sortDirection === 'asc') {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });
    }

    triggerFileInput(): void {
        this.fileInput.nativeElement.click();
    }

    // Import user function
    onImportFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            if (this.checkFileExtension(file)) {
                this.selectedFile = file;
                this.selectedFileName = file.name;
                this.isFileReady = true;
            } else {
                this.selectedFile = null;
                this.selectedFileName = '';
                this.isFileReady = false;
                Helpers.smallAlertBox("ERROR", 'File type is not suported', "ERROR", 5000);
            }
        } else {
            this.selectedFile = null;
            this.selectedFileName = '';
            this.isFileReady = false;
        }
    }

    onImportButton() {
        if (!this.selectedFile) {
            Helpers.smallAlertBox("ERROR", 'No file selected.', "ERROR", 5000);
            return;
        }
        if (!this.checkFileExtension(this.selectedFile)) {
            Helpers.smallAlertBox("ERROR", 'Invalid file type. Only .csv, .xls, .xlsx allowed.', "ERROR", 5000);
            return;
        }
        const file = this.selectedFile;
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const data = e.target.result;
            let result: { headers: string[], rows: any[][] } | null = null;
            if (file.name.endsWith('.csv')) {
                result = this.processCsvFile(data);
            } else {
                result = this.processExcelFile(data);
            }
            if (result) {
                const { headers, rows } = result;
                if (!this.validateRequiredHeaders(headers)) return;
                if (!this.validateRowData(rows, headers.length)) return;
                if (!this.validateEmailDomains(rows, headers)) return;
                if (this.selectedFile) {
                    const formData = new FormData();
                    formData.append('file_name', this.selectedFile);
                    formData.append('brand_id', this.helpersResponse?.brandDetails?._id);
                    formData.append('file_type', this.selectedFileName.substring(this.selectedFileName.lastIndexOf('.')));
                    formData.append('user_name', _.get(Helpers, 'managerDetails.manager.email_address'));
                    formData.append('version', 'v2');
                    this.settingsService.updateManagerListOrganisation(formData).subscribe(response => {
                        if(response) {
                            if (response.data.code == 0) {
                                this.selectedFile = null;
                                this.selectedFileName = '';
                                this.isFileReady = false;
                                Helpers.smallAlertBox("SUCCESS", "File is successfully uploaded,you will recieve notification email shortly", "SUCCESS", 5000);
                            } else if (response.data.code == 4100) {
                                Helpers.smallAlertBox("ERROR", " There was an error uploading this file to the server,please upload file again", "ERROR", 5000);
                            } else if (response.data.code == 4053) {
                                Helpers.smallAlertBox("ERROR", "There was an error uploading this file to the server ,please upload file again", "ERROR", 5000);
                            } else if (response.data.code == 2200) {
                                Helpers.smallAlertBox("Error", "There was an error uploading this file to the server ,please upload file again", "ERROR", 5000);
                            } else if (response.data.code == 4051) {
                                Helpers.smallAlertBox("ERROR", "There was an error uploading this file to the server, please upload file again", "ERROR", 5000);
                            } else if (response.data.code == 4052) {
                                Helpers.smallAlertBox("ERROR", "There was an error uploading this file to the server, please upload file again", "ERROR", 5000);
                            } else if (response.data.code == 4002) {
                                Helpers.smallAlertBox("ERROR", "There was an error uploading this file to the server, File type is not suported", "ERROR", 5000);
                            } else {
                                Helpers.smallAlertBox("ERROR", " There was an error uploading this file to the server, please upload file again", "ERROR", 5000);
                            }
                        } else {
                            this.selectedFile = null;
                            this.selectedFileName = '';
                            this.isFileReady = false;
                            Helpers.smallAlertBox("ERROR", "There was an error uploading this file to the server, please upload file again", "ERROR", 5000);
                        }
                    })
                }
            }
        };
        if (file.name.endsWith('.csv')) {
            reader.readAsText(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    }

    // Table header check
    validateRequiredHeaders(headers: string[]): boolean {
        const requiredHeaders = ['First Name', 'Last Name', 'Username', 'Email Address', 'Brand (1/0)'];
        const normalizedHeaders = Array.isArray(headers) ? headers.map(h => h.trim()) : [];
        const missingHeaders = requiredHeaders.filter(
            req => !normalizedHeaders.includes(req)
        );
        if (missingHeaders.length > 0) {
            Helpers.smallAlertBox('ERROR', `Missing required column(s): ${Array.isArray(missingHeaders) ? missingHeaders.join(', ') : ''}`, 'ERROR', 5000);
            return false;
        }
        return true;
    }

    // Validate each row
    validateRowData(dataRows: any[][], headerLength: number): boolean {
        for (let i = 0; i < dataRows.length; i++) {
            const row = dataRows[i];
            const hasMissing = row.length !== headerLength || row.some(cell => (cell === undefined || cell === null || (cell.toString && cell.toString().trim() === '')));
            if (hasMissing) {
                Helpers.smallAlertBox('ERROR', `Row ${i + 2} is incomplete. All ${headerLength} fields are required.`, 'ERROR', 5000);
                return false;
            }
        }
        return true;
    }

    // Validate domain
    validateEmailDomains(rows: any[][], headers: string[]): boolean {
        const emailColIndex = headers.findIndex(h => h === 'Email Address');
        if (emailColIndex === -1) {
            Helpers.smallAlertBox('ERROR', 'Email Address column not found.', 'ERROR', 5000);
            return false;
        }
        const validDomains = this.getValidDomains();
        for (let i = 0; i < rows.length; i++) {
            const email = rows[i][emailColIndex] ? rows[i][emailColIndex].toString().trim() : '';
            const emailDomain = email ? (email.split('@')[1] || '').toLowerCase() : '';
            if (!emailDomain || !validDomains.includes(emailDomain)) {
                Helpers.smallAlertBox('ERROR', `Invalid email domain in row ${i + 2}: "${email}". Allowed domains: ${Array.isArray(validDomains) ? validDomains.map(d => '@' + d).join(', ') : ''}`, 'ERROR', 5000);
                return false;
            }
        }
        return true;
    }

    getValidDomains(): string[] {
        const brandValidation = _.get(this.helpersResponse, 'brandDetails.security_settings.authentication.domain_validations', {});
        const accountValidation = _.get(this.helpersResponse, 'accountDetails.domain_validations', {});
        const brandEnabled = _.get(brandValidation, 'enable_manager_domain_validation', false);
        const accountEnabled = _.get(accountValidation, 'enable_manager_domain_validation', false);
        const defaultDomain = 'litmusworld.com';
        let validDomains: string[] = [defaultDomain];
        if (brandEnabled) {
            const brandDomains: string[] = _.get(brandValidation, 'valid_manager_domain_list', []);
            validDomains = Array.from(new Set([...brandDomains, defaultDomain]));
        } else if (accountEnabled) {
            const accountDomains: string[] = _.get(accountValidation, 'valid_manager_domain_list', []);
            validDomains = Array.from(new Set([...accountDomains, defaultDomain]));
        }
        return validDomains;
    }

    // Check CSV file is non empty
    processCsvFile(text) {
        const lines = (text || '').split('\n').map(line => line.trim()).filter(line => line !== '');
        if (lines.length < 2) {
            Helpers.smallAlertBox("ERROR", 'CSV file is empty or has no data rows.', "ERROR", 5000);
            return null;
        }
        const headers = (lines[0] || '').split(',').map(h => h.trim());
        const rows = (lines.slice(1) || []).map(line => (line || '').split(',').map(cell => cell.trim()));
        return { headers, rows };
    }

    // Check .xls, .xlsx file is non empty
    processExcelFile(data: ArrayBuffer): { headers: string[], rows: any[][] } | null {
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as any[][];
        if (!jsonData || jsonData.length < 2) {
            Helpers.smallAlertBox("ERROR", 'Excel file is empty or has no data rows.', "ERROR", 5000);
            return null;
        }
        const headers = (jsonData[0] || []).map(h => h.trim());
        const rows = jsonData.slice(1);
        return { headers, rows };
    }

    // Check file extension .xlsx, .xls, .csv
    checkFileExtension(file) {
        var allowedExtensions = ['.xlsx', '.xls', '.csv'];
        var fileName = '';
        if (typeof file === 'string') {
            fileName = file;
        } else if (file && file.name) {
            fileName = file.name;
        } else {
            return false;
        }
        var extension = fileName ? fileName.substring(fileName.lastIndexOf('.')).toLowerCase() : '';
        if (allowedExtensions.indexOf(extension) !== -1) {
            return true;
        } else {
            return false;
        }
    }

    loadMore() {
        if(this.isLoadMore) {
            this.getManagers().subscribe(response => {
                this.createUserListTable(response);
            })
        } else {
            this.isLoading = true;
            this.serachPayload = {
                ...this.serachPayload,
                page_number: this.serachPayload['page_number'] + 1
            };
            this.fetchSearchReult();
        }
    }

    onChipDropdownClick() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    onSearchInput(value: string) {
        this.apiOptions = [];
        this.searchTerm = value;
        const payload = {
            brand_id: this.helpersResponse?.brandDetails?._id,
            level: Object.keys(this.levelList).find(
                key => this.levelList[key] === this.newUserFormDataFrom.mainAccess
            ),
            value: this.searchTerm
        };
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.settingsService.getDynamicHierarchyList(payload).subscribe({
                next: response => {
                    if (response?.data?.is_value_available) {
                        this.apiOptions = response.data.level_values.map(item => item.name);
                    } else {
                        this.apiOptions = [];
                    }
                },
                error: err => {
                    this.apiOptions = [];
                }
            });
        }, 500);
    }

    get filteredOptionsDropdown(): string[] {
        if (!this.searchTerm || this.searchTerm.trim() === '') {
            return this.options;
        }
        return this.apiOptions;
    }

    toggleOption(option: string, event: Event): void {
        event.stopPropagation();
        const index = this.selectedItems.indexOf(option);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
        } else {
            this.selectedItems.push(option);
        }
        // Update subAccess array when chip selection changes
        this.onChipSelectionChange();
        this.checkForModification();
    }

    removeChip(item: string, event: Event): void {
        event.stopPropagation();
        this.selectedItems = this.selectedItems.filter(i => i !== item);
        // Update subAccess array when chip is removed
        this.onChipSelectionChange();
        this.checkForModification();
    }

    validation(type, value) {
        if (type === 'email') {
            if (!value || (value.trim && value.trim() === '')) {
                Helpers.smallAlertBox("ERROR", 'Email address is required.', "ERROR", 5000);
                this.isEmailValidate = false;
                return false;
            }

            // Basic email format regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value && value.trim ? value.trim() : '')) {
                Helpers.smallAlertBox("ERROR", 'Please enter a valid email address.', "ERROR", 5000);
                this.isEmailValidate = false;
                return false;
            }

            // Validate domain from getValidDomains()
            const validDomains = this.getValidDomains();
            const emailDomain = value && value.trim ? value.trim().split('@')[1] : '';
            if (!emailDomain || !validDomains.includes(emailDomain)) {
                Helpers.smallAlertBox("ERROR", `Please enter a valid domain. '${emailDomain}' is not allowed.`, "ERROR", 5000);
                this.isEmailValidate = false;
                return false;
            }
        } else if (type === 'phoneNumber') {
            const trimmedValue = value && value.trim ? value.trim() : '';
            if (trimmedValue === '') {
                this.isPhoneNumberValidate = true;
                return true;
            }
            const digitsOnly = trimmedValue.replace ? trimmedValue.replace(/\D/g, '') : '';
            if (digitsOnly.length !== 10) {
                Helpers.smallAlertBox("ERROR", 'Phone number must be exactly 10 digits.', "ERROR", 5000);
                this.isPhoneNumberValidate = false;
                return false;
            }
            this.isPhoneNumberValidate = true;
            return true;
        }
        this.isPhoneNumberValidate = true;
        this.isEmailValidate = true;
        return true;
    }

    isSelected(option: string): boolean {
        return Array.isArray(this.selectedItems) && this.selectedItems.includes(option);
    }

    @HostListener('document:mousedown', ['$event'])
    onClickOutside(event: Event): void {
        // Only close dropdown if clicking outside the chip-dropdown, not entire component
        const dropdownRef = this.chipDropdownContainer?.nativeElement;
        if (dropdownRef && !dropdownRef.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }

    mainAuthTypeFn(event) {
       this.mainAuthTypeChangeInNewUser = event?.name;
       this.newUserFormDataFrom.mainAuth = event?.name;
       
       // Automatically select the first sub auth type option
       const subOptions = this.passwordType.subPasswordType[event?.name];
       if (subOptions && subOptions.length > 0) {
           this.newUserFormDataFrom.subAuth = subOptions[0].name;
       }
    }

    subAuthTypeFn(event) {
        this.newUserFormDataFrom.subAuth = event?.name;
    }

    resetAccessValue() {
        // Reset the access value in the form data
        this.newUserFormDataFrom.subAccess = [];
        
        // Reset chip dropdown related fields
        this.selectedItems = [];
        this.searchTerm = '';
        this.isDropdownOpen = false;
        this.options = [];
    }

    onAccessValueInputChange(value: string) {
        // Handle input field changes - convert comma-separated string to array
        if (typeof value === "string" && value.trim()) {
            this.newUserFormDataFrom.subAccess = value.split(',').map(item => item.trim()).filter(item => item.length > 0);
        } else {
            this.newUserFormDataFrom.subAccess = [];
        }
    }

    getAccessValueAsString(): string {
        // Convert array to comma-separated string for input display
        return Array.isArray(this.newUserFormDataFrom.subAccess) 
            ? this.newUserFormDataFrom.subAccess.join(', ') 
            : '';
    }

    onChipSelectionChange() {
        // Handle chip dropdown changes - selectedItems is already an array
        this.newUserFormDataFrom.subAccess = [...this.selectedItems];
        this.editUserDetails.subAccess = [...this.selectedItems];
    }

    addNewOptionsFromSearch() {
        if (!this.searchTerm || typeof this.searchTerm !== 'string') return;
        const newItems = this.searchTerm.split(',')
                          .map(item => item.trim())
                          .filter(item => !!item && !this.options.includes(item));
        if (newItems.length > 0) {
            this.options = [...this.options, ...newItems];
            // Add to selected chips as well
            for (const item of newItems) {
                if (!this.selectedItems.includes(item)) {
                    this.selectedItems.push(item);
                }
            }
            this.onChipSelectionChange();
        }
        this.searchTerm = '';
        this.checkForModification();
    }

    isProfileFormValid(): boolean {
        const firstName = this.newUserFormDataFrom.firstName && this.newUserFormDataFrom.firstName.trim ? this.newUserFormDataFrom.firstName.trim() : '';
        const lastName = this.newUserFormDataFrom.lastName && this.newUserFormDataFrom.lastName.trim ? this.newUserFormDataFrom.lastName.trim() : '';
        const emailAddress = this.newUserFormDataFrom.emailAddress && this.newUserFormDataFrom.emailAddress.trim ? this.newUserFormDataFrom.emailAddress.trim() : '';
        const mainAuth = this.newUserFormDataFrom.mainAuth;
        const subAuth = this.newUserFormDataFrom.subAuth;
        const subAccess = this.newUserFormDataFrom.subAccess;
        return !!(firstName && lastName && emailAddress && mainAuth && subAuth && subAccess && subAccess.length > 0 && this.isEmailValidate && this.isPhoneNumberValidate && this.isAdidCorrect);
    }

    onNextButtonClick() {
        if (this.currentSubTab === 'profile') {
            this.positionOfKey = _.indexOf(_.values(this.levelList), this.newUserFormDataFrom.mainAccess);
            if(this.positionOfKey > 0) {
                this.newUserFormDataFrom.is_setting_access = false;
                this.newUserFormDataFrom.is_organisation_access = false;
            }
            this.changeSubTab('access');
        } else if (this.currentSubTab === 'access') {
            this.submitNewUser();
        }
    }

    submitNewUser() {
        this.SearchDropdownComponent.clearSearch(false);
        const paylaod = {
            "type": this.passwordType.mainPasswordType.find(item => item.name === this.newUserFormDataFrom.mainAuth)?.value,
            "sub_type": this.passwordType.subPasswordType[this.newUserFormDataFrom.mainAuth].find(item => item.name === this.newUserFormDataFrom.subAuth)?.value,
            "first_name": this.newUserFormDataFrom.firstName,
            "last_name": this.newUserFormDataFrom.lastName,
            "email_address": this.newUserFormDataFrom.emailAddress,
            "phone_number": this.newUserFormDataFrom.phoneNumber,
            "user_name": this.newUserFormDataFrom.emailAddress,
            "manager_type": 2,
            "brand_id": this.helpersResponse?.brandDetails?._id,
            "dynamic_properties": {
                "access_group": this.newUserFormDataFrom.accessGroup
            },
            "module_configuration_v2": {
                "studio": {
                    "visible": true,
                    "sub_modules": {
                        "organisation": {
                            "visible": this.newUserFormDataFrom.is_organisation_access
                        }
                    }
                },
                "advanced_download": {
                    "visible": this.newUserFormDataFrom.is_report_access
                }
            },
            "reply_back_allowed": this.newUserFormDataFrom.is_reply_access,
            "has_dashboard_access": this.newUserFormDataFrom.is_dashboard_access,
            "report_download_allowed": this.newUserFormDataFrom.is_report_access,
            "has_mobile_access": this.newUserFormDataFrom.is_mobile_access,
            "version": "v3",
            "is_organisation_tab": true
        }
        if(this.isAdidCorrect && this.adid) {
            paylaod['user_name'] = this.adid;
        }
        let levelKey = _.findKey(this.levelList, val => val === this.newUserFormDataFrom.mainAccess);
        if(levelKey) {
            paylaod['access_key'] = {
                "level": levelKey,
                "values": this.newUserFormDataFrom.subAccess
            }
        }
        if(this.cohortAccessList.length > 0) {
            const confirmedData = this.cohortAccessList.filter(item => item.confirmed).reduce((acc, item) => {
                acc[item.field_id] = item.value;
                return acc;
            }, {});
            paylaod['cohort_fields'] = confirmedData;
        }
        this.googleRecaptchaService.initializeToken().subscribe((token: string | null) => {
            if(token) {
                paylaod['g_recaptcha_response_v3'] = token;
                this.settingsService.registerManagerProfile(paylaod).subscribe(response => {
                    if(response && response.code === 0 && response.data && response.data.code === 0) {
                        Helpers.smallAlertBox("SUCCESS", "New manager registered successfully.", "SUCCESS", 5000);
                        this.userList = [];
                        this.filteredUserList = [];
                        this.pagination = {
                            last_index: 0,
                            page: 1
                        }
                        this.isLoadMore = false;
                        this.getManagers().subscribe(response => {
                            this.createUserListTable(response);
                        })
                    } else {
                        Helpers.smallAlertBox("ERROR", 'Something went wrong.', "ERROR", 5000);
                    }
                })
            }
        })
        this.closeRightPanelFN('New User Access');
    }

    selectLevelNewUser(event) {
        // Update the selected level in the form data
        this.newUserFormDataFrom.mainAccess = event.name;
        
        // Reset access value and related fields when level changes
        this.resetAccessValue();
        
        // Set hasLevelSelected to true when a real level is selected
        if (event.name !== 'Select Level') {
            this.hasLevelSelected = true;
            // Remove "Select Level" option from levelListArray once a real level is selected
            this.levelListArray = this.levelListArray.filter((level: any) => level.name !== 'Select Level');
        }
        
        this.isOptionsLoading = true;
        const paylaod = {
            brand_id: this.helpersResponse?.brandDetails?._id,
            level: event.filed_id,
            size: 40
        }
        this.settingsService.getDynamicHierarchyList(paylaod).subscribe(response => {
            this.isOptionsLoading = false;
            if (response?.code === 0 && response?.data?.code === 0) {
                if (response.data.level_values && response.data.level_values.length > 0) {
                    this.options = response.data.level_values.map(item => item.name);
                } else {
                    Helpers.smallAlertBox("ERROR", 'No value is present for this hierarchy level', "ERROR", 5000);
                }
            } else if(event.name !== 'Select Level') {
                Helpers.smallAlertBox("ERROR", 'Something went wrong.', "ERROR", 5000);
            }
        }, error => { this.isOptionsLoading = false; });
    }

    getChorot() {
        const fieldDefinitions = _.get(this.helpersResponse, 'brandDetails.field_definitions');
        const result: any = [{name: 'Select a Tag Parameter', field_id: null}];
        if (fieldDefinitions && Object.keys(fieldDefinitions).length > 0) {
            _.forEach(fieldDefinitions, (fieldDefinition) => {
                if (fieldDefinition.compare_filter === true) {
                    result.push({name: fieldDefinition.name, field_id: fieldDefinition.field_id});
                }
            });
        }
        this.cohortLevels = result;
    }

    addChohortNewAccess() {
        const unconfirmedRow = this.cohortAccessList.find(r => !r.confirmed);
        if (unconfirmedRow) {
            Helpers.smallAlertBox("ERROR", 'Please confirm the previous cohort value before adding a new row.', "ERROR", 5000);
            return;
        }
        this.cohortAccessList.push({selectedLevel: null, value: '', confirmed: false});
    }

    onCohortLevelChange(event: any, index: number) {
        this.cohortAccessList[index].selectedLevel = event.name;
        this.cohortAccessList[index].field_id = event.field_id;
    }

    getAvailableOptions(currentIndex: number) {
        const selectedNames = this.cohortAccessList.filter((_, i) => i !== currentIndex).map(row => row.field_id).filter(field_id => !!field_id);
        return this.cohortLevels.filter(level => !selectedNames.includes(level.field_id) || level.field_id === this.cohortAccessList[currentIndex].field_id);
    }

    confirmRow(index: number) {
        const row = this.cohortAccessList[index];
        if (!row.selectedLevel || row.selectedLevel === 'Select a Tag Parameter') {
            Helpers.smallAlertBox("ERROR", 'Please select a valid cohort level before confirming.', "ERROR", 5000);
            return;
        }
        if (!row.value) {
            Helpers.smallAlertBox("ERROR", 'Please enter a value for this cohort.', "ERROR", 5000);
            return;
        }
        if (typeof row.value === 'string') {
            row.value = row.value.split(',').map(item => item.trim()).filter(item => item !== '');
        }
        row.confirmed = true;
    }

    sendVerificationMail(userDetails) {
        const uuid: any = _.get(userDetails, 'uuid');
        const lastUpdated = _.get(userDetails, 'doc_last_updated_on');  
        const canResend = this.canResendVerification(lastUpdated);
        if (!canResend) {
            return;
        }
        if(this.verificationMailSentCache.indexOf(uuid) > -1) {
            return;
        }
        this.verificationMailSentCache.push(uuid);
        const payload = {
            manager_id: _.get(userDetails, 'managerFullDetails._id'),
            brand_id: this.helpersResponse?.brandDetails?._id,
            version: "v3"
        }
        this.settingsService.sendVerificationMail(payload).subscribe(response => {
            if (response && response.code === 0 && response.data && response.data.code === 0) {
                Helpers.smallAlertBox("SUCCESS", 'Verify email send successfully', "SUCCESS", 5000);
            } else {
                Helpers.smallAlertBox("ERROR", 'Something went wrong.', "ERROR", 5000);
            }
        })
    }

    canResendVerification(lastUpdated) {
        if (!lastUpdated) return true;
        const last = new Date(lastUpdated).getTime();
        const now = Date.now();
        const diffHours = (now - last) / (1000 * 60 * 60);
        return diffHours > 24;
    }

    checkLoginType(){
        let accountDetailLDAP = _.get(this.helpersResponse, "accountDetails.client_ldap_config.is_enabled");
        let accountDetailSSO = _.get(this.helpersResponse, "accountDetails.client_sso_config.is_enabled");
        let checkSSOandLDAPinBrand = this.checkSSOLDAP();
        if(accountDetailSSO || accountDetailLDAP || checkSSOandLDAPinBrand){
            return false;
        }else{
            return true;
        }
    }

    checkSSOLDAP(){
        let priority_list = _.get(this.helpersResponse, "brandDetails.security_settings.authentication.login.priority_list");
        if(priority_list){
            if(priority_list.indexOf('ldap')>-1 || priority_list.indexOf('sso')>-1){
                let loginType = _.get(this.helpersResponse, "brandDetails.security_settings.authentication.login");
                let grabLoginType=grabLoginTypeFun();
                function grabLoginTypeFun() {
                    for(let i=0; i<loginType.priority_list.length; i++){
                        let loginTypeKey=loginType.priority_list[i];
                        if (loginType[loginTypeKey]["is_enabled"]){
                            return loginTypeKey;
                        }
                    }
                    return "password";
                }
                if(grabLoginType !== "sso" || grabLoginType !== "ldap"){
                    return false;
                }
            }
        }
        return false;
    }

    validateADID(userName){
        let regex = /^[a-zA-Z0-9@\-_]*$/;
        this.isAdidCorrect = regex.test(userName);
        if(!this.isAdidCorrect) {
            Helpers.smallAlertBox('ERROR', 'Please enter correct Agent ID / ADID.', 'ERROR', 5000);
        }
    }

    isVisibilityGroupFn() {
        this.visibilityGroup = _.get(this.helpersResponse, 'brandDetails.dynamic_properties.access_group');
        return this.visibilityGroup.length > 0;
    }

    onAccessGroupChange(event: any, groupId: number) {
        if (event.target.checked) {
            if (!this.newUserFormDataFrom.accessGroup.includes(groupId)) {
                this.newUserFormDataFrom.accessGroup.push(groupId);
            }
        } else {
            this.newUserFormDataFrom.accessGroup = this.newUserFormDataFrom.accessGroup.filter(id => id !== groupId);
        }
    }

    toggleCheckbox(user: any, key: string) {
        if (user.source !== 'dashboard' || (!user.hasDashboardAccess && key !== 'hasDashboardAccess') || user.statusInfo?.status === 'Unverified') {
            return;
        }
        if(user.managerType !== 3 && user.source === 'dashboard' && user.statusInfo?.status === 'Active' && this.showPermissionToggles) {
            return;
        }
        user[key] = !user[key];
        this.onCheckboxChange(user, key, { target: { checked: user[key] } });
    }

    syncAllDropdowns(email: string, status: string) {
        this.filteredOptions.emailVerification = [...this.filteredOptions.emailVerificationMaster];
        this.filteredOptions.status = [...this.filteredOptions.statusMaster];
        if (email === 'Verified') {
            this.filteredOptions.status = this.filteredOptions.status.filter(
                s => ['All', 'Active', 'Inactive'].includes(s.name)
            );
        } else if (email === 'Unverified') {
            this.filteredOptions.status = this.filteredOptions.status.filter(
                s => ['All', 'Unverified'].includes(s.name)
            );
        }
        if (status === 'Active' || status === 'Inactive') {
            this.filteredOptions.emailVerification = this.filteredOptions.emailVerification.filter(
                e => ['All', 'Verified'].includes(e.name)
            );
        } else if (status === 'Unverified') {
            this.filteredOptions.emailVerification = this.filteredOptions.emailVerification.filter(
                e => ['All', 'Unverified'].includes(e.name)
            );
        }
        if (!this.filteredOptions.status.some(s => s.name === this.statusSelectedOptionCache)) {
            this.statusSelectedOption = this.statusSelectedOptionCache = 'All';
        }
        if (!this.filteredOptions.emailVerification.some(e => e.name === this.emailVerificationSelectedOptionCache)) {
            this.emailVerificationSelectedOption = this.emailVerificationSelectedOptionCache = 'All';
        }
    }

    clearAllFilter() {
        this.dropdownResetKey = false;
        this.emailVerificationSelectedOption = this.filteredOptions.emailVerificationMaster[0].name
        this.emailVerificationSelectedOptionCache = this.filteredOptions.emailVerificationMaster[0].name
        this.userTypeSelectedOption = this.filteredOptions.userType[0].name
        this.userTypeSelectedOptionCache = this.filteredOptions.userType[0].name
        this.statusSelectedOption = this.filteredOptions.statusMaster[0].name
        this.statusSelectedOptionCache = this.filteredOptions.statusMaster[0].name
        this.isApplyEnabled = !this.isApplyEnabled;
        this.syncAllDropdowns('All', 'All');
        setTimeout(() => {
            this.dropdownResetKey = true;
        });
    }

    getToggleImage(user: any, key: string): string {
        if (user.managerType === 3 && (key === 'replyBackAllowed' || key === 'reportDownloadAllowed')) {
            return 'assets/images/toggle-switch.svg';
        }
        if (this.showPermissionToggles && user.managerType !== 3 && user.source === 'dashboard' && user.statusInfo?.status !== 'Unverified') {
            if (user.selected) {
                return this.headerToggles[key] ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg';
            }
            return 'assets/images/toggle-switch.svg';
        }
        return user[key] && user.statusInfo?.status === 'Active' ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg';
    }

    isToggleBlocked(user: any, key: string): boolean {
        return (
            user.source !== 'dashboard' ||
            (!user.hasDashboardAccess && key !== 'hasDashboardAccess') ||
            user.statusInfo?.status === 'Unverified' ||
            user.managerType === 3 || 
            user.managerType !== 3 && user.source === 'dashboard' && user.statusInfo?.status !== 'Unverified' && this.showPermissionToggles
        );
    }

    onToggleClick(user: any, key: string): void {
        if(!this.isUserHasWriteAccess) {
            Helpers.smallAlertBox('Access Denied', 'You do not have write permission to update user details. Only read access is available.', 'warning', 4000);
            return;
        }
        if (user.managerType !== 3) {
            this.toggleCheckbox(user, key);
        }
    }

    onSelectAllChange() {
        this.filteredUserList.forEach(user => {
            const isSelectable =
            user.managerType !== 3 &&
            user.source === 'dashboard' &&
            user.statusInfo?.status !== 'Unverified';
            if (isSelectable) {
            user.selected = this.selectAll;
            }
        });
        this.showPermissionToggles = this.selectAll;
        if (!this.selectAll) {
            this.resetHeaderToggles();
        }
    }

    updateSelectAllState() {
        const selectableUsers = this.filteredUserList.filter(
            u =>
            u.managerType !== 3 &&
            u.source === 'dashboard' &&
            u.statusInfo?.status !== 'Unverified'
        );
        this.selectAll = selectableUsers.length > 0 && selectableUsers.every(u => u.selected);
        this.showPermissionToggles = selectableUsers.some(u => u.selected);
        const anySelected = selectableUsers.some(u => u.selected);
        this.showPermissionToggles = anySelected;
        if (!anySelected) {
            this.resetHeaderToggles();
        }
    }

    resetHeaderToggles() {
        Object.keys(this.headerToggles).forEach(key => {
            this.headerToggles[key] = false;
        });
    }

    toggle(key: keyof typeof this.headerToggles) {
        this.headerToggles[key] = !this.headerToggles[key];
    }

    get isBulkSaveActive(): boolean {
        if (!this.showPermissionToggles) {
            return false;
        }
        return Object.values(this.headerToggles).some(value => value === true);
    }

    bulkUpdate() {
        this.SearchDropdownComponent.clearSearch(false);
        const selectedUsers = this.filteredUserList.filter(
            user =>
            user.selected &&
            user.managerType !== 3 &&
            user.source === 'dashboard' &&
            user.statusInfo?.status !== 'Unverified'
        );
        if (!selectedUsers.length) {
            return;
        }
        const uniqueManagerIds = Array.from(
            new Set(
            selectedUsers
                .map(user => user.managerFullDetails?._id)
                .filter(Boolean)
            )
        );
        let paylaod = {
            source: "LW3",
            brand_id: this.helpersResponse?.brandDetails?._id,
            reply_back_allowed: this.headerToggles['replyBackAllowed'],
            report_download_allowed: this.headerToggles['reportDownloadAllowed'],
            has_mobile_access: this.headerToggles['hasMobileAccess'],
            has_dashboard_access: this.headerToggles['hasDashboardAccess'],
            has_studio_access: false,
            has_organisation_access: false,
            managers_list: uniqueManagerIds
        }
        this.resetHeaderToggles();
        this.selectAll = false;
        this.showPermissionToggles = false;
        this.settingsService.managersBulkUpdate(paylaod).subscribe(response => {
            if(response && response.code == 0 && response.data && response.data.code == 0) {
                Helpers.smallAlertBox("SUCCESS", 'Access details updated successfully', "SUCCESS", 5000);
                this.userList = [];
                this.filteredUserList = [];
                this.pagination = {
                    last_index: 0,
                    page: 1
                }
                this.isLoadMore = false;
                this.getManagers().subscribe(response => {
                    this.createUserListTable(response);
                })
            } else {
                Helpers.smallAlertBox("ERROR", "Failed to update access details.", "ERROR", 5000);
            }
        })
    }
}